import React from 'react'

export default function HomePlatformMessageEn() {
  return (
    <p className="text-4xl font-black leading-[1.75] xl:text-5xl xl:leading-[1.8]">
      <span className="text-secondary-600">Arab Mineral Resources </span>
      <br />A bridge to a better <br />
      <span className="text-third">& sustainable future</span>
    </p>
  )
}
